/**
 * Extended Error class that preserves backend error details
 * including structured information like requiresReconnection
 */
export class ApiError extends Error {
  public statusCode?: number;
  public details?: {
    provider?: string;
    requiresReconnection?: boolean;
    message?: string;
    [key: string]: unknown;
  };

  constructor(message: string, statusCode?: number, details?: ApiError['details']) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.details = details;
  }
}
